/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { Spinner } from '@squiz/sds';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { DIRECTORY_VIEWER_STRINGS } from './DirectoryViewer.constants';
import { DirectoryViewerProps } from './DirectoryViewer.props';
import { DirectoryNode } from './elements/DirectoryNode/DirectoryNode';

export const DirectoryViewer = ({ initialData, value, setValue, error = false }: DirectoryViewerProps): JSX.Element => {
  const { t } = useTranslation();

  const viewerRef = useRef<HTMLDivElement>(null);

  const labels = {
    errorLoadingDirectoryContents: t(DIRECTORY_VIEWER_STRINGS.errorLoadingDirectoryContents),
  };

  if (error) {
    return (
      <div className="directory-viewer directory-viewer--error">
        <p className="directory-viewer__error-message">{labels.errorLoadingDirectoryContents}</p>
      </div>
    );
  }
  if (!initialData) {
    return (
      <div className="directory-viewer directory-viewer--loading">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="directory-viewer" ref={viewerRef}>
      <DirectoryNode
        isSelected={value === '/'}
        key="/"
        node={{ path: '/', type: 'DIRECTORY' }}
        setValue={setValue}
        value={value}
        viewerRef={viewerRef}
      />
      {initialData
        .filter((item) => item.type === 'DIRECTORY')
        .map((dir) => {
          return (
            <DirectoryNode
              isSelected={value === dir.path}
              key={dir.path}
              node={dir}
              preloadedChildren={dir.children}
              setValue={setValue}
              value={value}
              viewerRef={viewerRef}
            />
          );
        })}
    </div>
  );
};
